import React, { useState, useEffect } from 'react';
import { Box, Header, Content, CloseIcon } from './styles';

export default () => {
  const [shouldShow, setShouldShow] = useState(true);

  useEffect(() => {
    const hasClosed = localStorage.getItem('has_closed_rules_info');

    if (hasClosed) {
      setShouldShow(false);
    }
  }, []);

  const closeBanner = () => {
    localStorage.setItem('has_closed_rules_info', 'true');
    setShouldShow(false);
  };

  return !shouldShow ? null : (
    <Box>
      <CloseIcon onClick={() => closeBanner()} />
      <Header>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 511.997 511.997">
          <path d="M57.318 166.155H12.746C5.905 166.155.36 171.7.36 178.541s5.545 12.386 12.386 12.386h44.571c6.842 0 12.387-5.545 12.387-12.386s-5.545-12.386-12.386-12.386zM499.251 166.155h-44.572c-6.84 0-12.386 5.545-12.386 12.386s5.546 12.386 12.386 12.386h44.572c6.84 0 12.386-5.545 12.386-12.386s-5.546-12.386-12.386-12.386zM108.347 326.191c-4.837-4.837-12.679-4.837-17.517 0l-32.42 32.42c-4.837 4.837-4.837 12.679 0 17.517 2.419 2.419 5.589 3.628 8.758 3.628s6.34-1.209 8.758-3.628l32.421-32.42c4.837-4.836 4.837-12.679 0-17.517zM430.912 3.628c-4.838-4.837-12.678-4.837-17.517 0L381.863 35.16c-4.837 4.837-4.837 12.68 0 17.516a12.359 12.359 0 0 0 8.759 3.627c3.171 0 6.339-1.21 8.758-3.628l31.531-31.531c4.837-4.837 4.837-12.68.001-17.516zM130.117 35.142L98.602 3.628c-4.837-4.835-12.68-4.835-17.517 0-4.837 4.837-4.837 12.68 0 17.517L112.6 52.66c2.419 2.418 5.589 3.628 8.758 3.628s6.34-1.21 8.758-3.628c4.837-4.837 4.837-12.68.001-17.518zM453.585 358.615l-32.3-32.303c-4.838-4.837-12.678-4.837-17.517.001-4.837 4.837-4.837 12.68 0 17.516l32.301 32.301a12.347 12.347 0 0 0 8.758 3.628c3.171 0 6.339-1.21 8.758-3.628 4.837-4.836 4.837-12.679 0-17.515zM255.999 33.636c-85.648 0-155.327 72.885-155.327 162.474 0 41.65 14.919 86.482 40.933 123 19.979 28.045 30.538 59.249 30.538 90.24v77.875c0 13.659 11.113 24.772 24.772 24.772h118.169c13.659 0 24.772-11.113 24.772-24.772V409.35c0-30.99 10.559-62.195 30.536-90.24 26.014-36.517 40.934-81.35 40.934-123-.002-89.589-69.681-162.474-155.327-162.474zm59.083 453.591H196.913v-16.201h59.085c6.841 0 12.387-5.545 12.387-12.386s-5.546-12.386-12.387-12.386h-59.085v-16.2h118.172l.014 57.171c-.001.002-.006.002-.017.002zm-76.453-231.086l-16.564-35.387h67.866l-16.562 35.387a12.414 12.414 0 0 0-1.142 4.43l-9.605 144.711h-13.247l-9.605-144.711a12.413 12.413 0 0 0-1.141-4.43zm111.586 48.597c-22.123 31.056-34.208 65.733-35.082 100.544h-27.684l9.341-140.749 23.831-50.915a12.385 12.385 0 0 0-11.218-17.637H202.592a12.385 12.385 0 0 0-11.218 17.636l23.832 50.915 9.341 140.749h-27.686c-.874-34.812-12.958-69.488-35.082-100.544-22.754-31.942-36.338-72.551-36.338-108.628 0-75.93 58.567-137.702 130.555-137.702s130.555 61.772 130.555 137.702c.002 36.079-13.582 76.688-36.336 108.629z" />
        </svg>
        <h4>Nya regler kring byten</h4>
      </Header>
      <Content>
        <p>
          <strong>
            Från och med 1 Oktober 2019 gäller nya regler för hyresmarkanden.
          </strong>
        </p>
        <p>
          Du vet väl att för att få byta en hyresrätt mot en annan hyresrätt
          behöver du tillstånd från hyresvärden eller från hyresnämnden.
          <br />
          <strong>
            Både du som hyresgäst och den du vill byta lägenhet med behöver
            också som huvudregel ha bott i lägenheten i 1 år.
          </strong>
          <br />
          Vid frågor gällande detta kontaktar du din hyresvärd direkt.
        </p>

        <p>
          <a
            href="https://www.hyresgastforeningen.se/stod-och-rad/andrahand-och-inneboende/lagenhetsbyte"
            rel="noopener noreferrer"
            target="_blank">
            Läs mer om detta och övriga lagändringar här.
          </a>
        </p>
      </Content>
    </Box>
  );
};



// WEBPACK FOOTER //
// ./src/components/RulesInfo/RulesInfo.js